'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Salespitch = function Salespitch(_ref) {
    var theme = _ref.theme,
        target = _ref.target,
        salespitch = _ref.salespitch,
        salespitchContent = _ref.salespitchContent;

    if (target === 'app') {
        return _react2.default.createElement(
            'div',
            { className: theme.salespitchContent },
            _react2.default.createElement(
                'div',
                { id: 'IAPbreadCrumbs', className: theme.IAPbreadCrumbs },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(theme.crumb, theme.complete) },
                    _react2.default.createElement(
                        'div',
                        { className: theme.crumbMarker },
                        '1'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: theme.crumbText },
                        'Velg abonnement'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: theme.crumb },
                    _react2.default.createElement(
                        'div',
                        { className: theme.crumbMarker },
                        '2'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: theme.crumbText },
                        'Logg inn'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: theme.crumb },
                    _react2.default.createElement(
                        'div',
                        { className: theme.crumbMarker },
                        '3'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: theme.crumbText },
                        'Betal'
                    )
                )
            ),
            _react2.default.createElement(
                'p',
                null,
                'I VG+ f\xE5r du eksklusive artikkelserier, fordypning i nyhetssaker og tilgang til hele v\xE5rt dokumentarbibliotek.'
            )
        );
    }

    return _react2.default.createElement(
        'div',
        { 'data-test-tag': '@vg/salesposter:pitch' },
        _react2.default.createElement(
            'span',
            null,
            salespitch || 'Som abonnent får du'
        ),
        _react2.default.createElement(
            'div',
            { className: theme.salespitchContent },
            salespitchContent || 'Eksklusive artikkelserier | Fordypning i nyhetssaker | Tilgang til hele vårt',
            ' '
        )
    );
};

Salespitch.propTypes = {
    theme: _propTypes2.default.shape({
        salespitchContent: _propTypes2.default.string
    }),
    target: _propTypes2.default.string,
    salespitch: _propTypes2.default.string,
    salespitchContent: _propTypes2.default.string
};

Salespitch.defaultProps = {
    theme: {},
    target: 'web',
    salespitch: '',
    salespitchContent: ''
};

exports.default = Salespitch;
//# sourceMappingURL=Salespitch.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/salesposter/lib/cjs/Salespitch.js
 ** module id = 739
 ** module chunks = 1
 **/